"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowOnScreenSizes = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
exports.ShowOnScreenSizes = styled_components_1.styled.span `
  @media screen and (max-width: ${(props) => props.theme.screen.small}) {
    display: ${(p) => (p.small ? "contents" : "none")};
  }
  @media screen and (min-width: ${(props) => props.theme.screen.small}) and (max-width: ${(props) => props.theme.screen.medium}) {
    display: ${(p) => (p.medium ? "contents" : "none")};
  }
  @media screen and (min-width: ${(props) => props.theme.screen.medium}) and (max-width: ${(props) => props.theme.screen.large}) {
    display: ${(p) => (p.large ? "contents" : "none")};
  }
  @media screen and (min-width: ${(props) => props.theme.screen.large}) {
    display: ${(p) => (p.xLarge ? "contents" : "none")};
  }
`;
//# sourceMappingURL=Responsive.js.map